'use client'
import { AnimatedGridPattern } from '@/components/ui/animated-grid-pattern'
import { MessageDescriptor } from '@lingui/core'
import { useLingui } from '@lingui/react'
import { motion } from 'framer-motion'
import * as React from 'react'

export type SiteHeadingProps = {
  badge?: MessageDescriptor
  title?: MessageDescriptor
  description?: MessageDescriptor
}

export function SiteHeading({ badge, title, description }: SiteHeadingProps): React.JSX.Element {
  const { i18n } = useLingui()

  return (
    <div className='relative flex flex-col items-center justify-center space-y-4 text-center py-8 md:py-12'>
      <div className='absolute inset-0 [mask-image:radial-gradient(ellipse_at_center,white,transparent)]'>
        <AnimatedGridPattern />
      </div>
      {badge && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className='rounded-3xl z-10 relative bg-orange-400/10 px-4 py-2 text-sm text-orange-600 dark:text-orange-400'
        >
          {i18n._(badge)}
        </motion.div>
      )}
      {title && (
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className='font-bold z-10 tracking-tight text-3xl sm:text-4xl md:text-5xl text-foreground'
        >
          {i18n._(title)}
        </motion.h2>
      )}
      {description && (
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className='text-muted-foreground z-10 max-w-2xl mx-auto text-base sm:text-lg'
        >
          {i18n._(description)}
        </motion.p>
      )}
    </div>
  )
}
